import { Dispatch, SetStateAction, createContext } from "react";
import { Office, Territory } from "../../models";

export interface ITerritoryContext {
    territories: Territory[];
    offices: Office[];
    selectedTerritoryIds: number[];
    selectedOfficeIds: number[];
    toggleTerritory: (id: number) => void;
    toggleOffice: (officeId: number, territoryId: number) => void;
    selectedTerritories: Territory[];
    selectedOffices: Office[];
    handleSelectAllOffices: () => void;
    allOfficesSelected: boolean;
    setSelectedTerritoryIds: Dispatch<SetStateAction<number[]>>;
    setSelectedOfficeIds: Dispatch<SetStateAction<number[]>>;
}

const defaultValue: ITerritoryContext = {
    territories: [],
    offices: [],
    selectedTerritoryIds: [],
    selectedOfficeIds: [],
    toggleTerritory: () => {},
    toggleOffice: () => {},
    selectedTerritories: [],
    selectedOffices: [],
    handleSelectAllOffices: () => {},
    allOfficesSelected: false,
    setSelectedTerritoryIds: () => {},
    setSelectedOfficeIds: () => {},
};

export const TerritoryContext = createContext<ITerritoryContext>(defaultValue);
TerritoryContext.displayName = "Territory";
